import React from 'react';
import CloseIcon from 'react-icons/lib/md/close';

import './infobox.styl';

const Infobox = (props) => {
  const onClose = () => {
    props.onClose();
  };

  if (!props.isActive) {
    return null;
  }

  return (
    <div className="ifdw-infobox">
      <div className="ifdw-infobox--close" onClick={onClose} role="button" tabIndex={0}><CloseIcon /></div>
      {props.component}
    </div>
  );
};

export default Infobox;



// WEBPACK FOOTER //
// ./src/components/Infobox/index.js